import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Loader2, Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); }
    catch { /* generic — never reveal existence */ }
    setSent(true); setLoading(false);
  };

  return (
    <div className="min-h-[70vh] grid place-items-center px-4 py-12">
      <div className="w-full max-w-md bg-card rounded-2xl border border-border p-7" data-testid="forgot-password-page">
        <Link to="/login" className="text-sm text-muted-foreground flex items-center gap-1 mb-4" data-testid="back-to-login"><ArrowLeft size={15} /> Back to sign in</Link>
        <h1 className="font-display text-2xl font-bold">Reset your password</h1>
        {sent ? (
          <p className="text-sm text-muted-foreground mt-3" data-testid="forgot-sent">If an account exists for <b>{email}</b>, we've emailed a password reset link. It expires in 1 hour. Check your inbox (and spam).</p>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-3">
            <p className="text-sm text-muted-foreground">Enter your email and we'll send you a secure link to set a new password.</p>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="w-full rounded-xl border border-border pl-9 pr-4 py-3 text-sm" data-testid="forgot-email" />
            </div>
            <button disabled={loading} className="w-full bg-ink text-white rounded-xl py-3 font-semibold flex items-center justify-center gap-2 disabled:opacity-60" data-testid="forgot-submit">
              {loading ? <Loader2 size={18} className="animate-spin" /> : null} Send reset link
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
